export default {
  app: {
    name: "Sportsbook",
    full: "Back Office Template",
    minimized: "BO"
  },
  no_records: "No records",
  welcome: "Chào mừng trở lại, {user}!",
  login: "đăng nhập",
  login_success: "Đăng nhập thành công",
  relogin: "Vui lòng đăng nhập lại vào tài khoản của bạn.",
  expired: "Bạn đã đăng xuất do nhiều lần đăng nhập!",
  denied: "Quyền bị từ chối!",
  success: "Bạn đã hoàn thành thành công!",
  select_date_range: "Vui lòng chọn một ngày",
  permission_denied: "Bạn không được phép thực hiện hành động này!",
  search_by_id_name: "Tìm kiếm theo ID hoặc Tên",
  search_by_name: "Tìm kiếm theo tên",
  close: "Tài khoản đã đóng. Vui lòng liên hệ với quản trị viên của bạn.",
  suspend: "toàn khoản bị đình chỉ. Vui lòng liên hệ với quản trị viên của bạn.",
  suspend_alert1: "Tài khoản của bạn đã được thay đổi thành \"Chỉ xem\".",
  suspend_alert2: "Vui lòng tham khảo Upline của bạn.",
  freeze: "tài khoản bị đóng băng. Vui lòng liên hệ với quản trị viên của bạn.",
  account_id_length_error: "Độ dài id tài khoản không hợp lệ",
  change_user_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái Tài khoản?",
  delete_confirm: "Bạn có chắc chắn muốn xóa \"{name}\"?",
  update_account_status_confirm: "Bạn có chắc chắn muốn cập nhật trạng thái tài khoản?",
  update_account_status_cancel: "Cập nhật trạng thái tài khoản không thành công.",
  update_account_status_success: "Tình trạng tài khoản được cập nhật thành công!",
  update_account_password_confirm: "Bạn có chắc chắn muốn cập nhật mật khẩu tài khoản của mình?",
  update_account_password_cancel: "Cập nhật mật khẩu tài khoản không thành công.",
  update_account_password_success: "Đã cập nhật mật khẩu thành công!",
  update_account_security_confirm: "Bạn có chắc chắn muốn cập nhật bảo mật tài khoản?",
  update_account_security_cancel: "Cập nhật bảo mật tài khoản không thành công.",
  update_account_security_success: "Bảo mật tài khoản được cập nhật thành công!",
  update_account_authority_confirm: "Bạn có chắc chắn muốn cập nhật thẩm quyền tài khoản?",
  update_account_authority_cancel: "Cập nhật thẩm quyền tài khoản không thành công.",
  update_account_authority_success: "Quyền tài khoản được cập nhật thành công!",
  block_sub_account_confirm: "Bạn có chắc chắn muốn chặn tài khoản phụ?",
  block_sub_account_cancel: "Khối tài khoản phụ không thành công.",
  block_sub_account_success: "Tài khoản phụ bị chặn thành công!",
  unblock_sub_account_confirm: "Bạn có chắc chắn muốn bỏ chặn tài khoản phụ?",
  unblock_sub_account_cancel: "Bỏ chặn tài khoản phụ không thành công.",
  unblock_sub_account_success: "Tài khoản phụ đã được bỏ chặn thành công!",
  successful_update_profile: "Bạn đã cập nhật thành công hồ sơ của bạn.",
  successful_update_security: "Bạn đã cập nhật thành công mã bảo mật.",
  successful_create_account: "Bạn đã tạo thành công một tài khoản mới. ",
  update_platform_settings_confirm: "Bạn có chắc chắn muốn cập nhật cài đặt nền tảng?",
  update_platform_settings_cancel: "Cập nhật cài đặt nền tảng không thành công.",
  update_platform_settings_success: "Cài đặt nền tảng cập nhật thành công!",
  reset_accumulate_win_confirm: "Bạn có chắc chắn muốn thiết lập lại giới hạn tích lũy?",
  reset_accumulate_win_cancel: "Đặt lại tích lũy giới hạn chiến thắng không thành công.",
  reset_accumulate_win_success: "Tích trữ giới hạn thắng thiết lập lại thành công!",
  parent_platform_disabled: "Cài đặt nền tảng đường lên đã bị vô hiệu hóa.",
  copy_success: "Thông tin tài khoản đã được sao chép vào clipboard.",
  copy_failed: "Trình duyệt của bạn không hỗ trợ sao chép vào clipboard.",
  copy_all_upline: "Sao chép Bóng Đá HDP đại lý tuyến trê lớn tất cả thể thao",
  copy_all_account: "Sao chép Bóng Đá HDP tất cả thể thao Tài Khoản",
  copy_all_remaining: "Sao chép Bóng Đá HDP tất cả thể Còn lại",
  copy_all_min: "Sao chép Bóng Đá HDP PT Đặt tất cả",
  copy_all_min_bet: "Sao chép Bóng Đá Đặt tất cả thể cược tối thiểu",
  copy_all_max_bet: "Sao chép Bóng Đá Đặt tất cả thể Đặt Cược Tối Đa",
  copy_all_max_per_match: "Sao chép Bóng Đá tất cả thể Tối Đa Cho Mỗi Trận",
  create_secondary_account_success: "Tài khoản phụ đã được tạo thành công! Xin vui lòng đăng nhập lại.",
  first_sub_account_success: "Tài khoản phụ được cập nhật thành công! Xin vui lòng đăng nhập lại.",
  update_account_commission_confirm: "Bạn có chắc chắn muốn cập nhật hoa hồng tài khoản?",
  update_account_commission_cancel: "Cập nhật hoa hồng tài khoản không thành công.",
  update_account_commission_success: "Hoa hồng tài khoản được cập nhật thành công!",
  update_account_position_confirm: "Bạn có chắc chắn muốn cập cấp độ tài khoản?",
  update_account_position_cancel: "muốn cập Tài Khoản cấp độ Thất bại.",
  update_account_position_success: "Vị trí tài khoản được cập nhật sự thành công!",
  update_account_bet_limit_confirm: "Bạn có chắc chắn muốn cập nhật giới hạn đặt cược tài khoản của mình không?",
  update_account_bet_limit_cancel: "Không thể cập nhật giới hạn đặt cược tài khoản.",
  update_account_bet_limit_success: "Giới hạn đặt cược tài khoản đã được cập nhật thành công!",
  update_account_profile_confirm: "Bạn có chắc chắn muốn cập nhật hồ sơ tài khoản?",
  update_account_profile_cancel: "Không thể cập nhật hồ sơ tài khoản.",
  update_account_profile_success: "Hồ sơ tài khoản được cập nhật thành công!",
  create_new_account_confirm: "Bạn có chắc chắn muốn tạo một tài khoản mới?",
  create_new_account_cancel: "Tạo một tài khoản mới không thành công",
  create_new_account_success: "Tài khoản mới được tạo thành công!",
  create_sub_account_confirm: "Bạn có chắc chắn muốn tạo một tài khoản phụ?",
  create_sub_account_cancel: "Tạo tài khoản phụ không thành công",
  create_sub_account_success: "Tài khoản phụ đã được tạo thành công!",
  update_sub_account_confirm: "Bạn có chắc chắn muốn cập nhật tài khoản phụ?",
  update_sub_account_cancel: "Cập nhật phụ không thành công",
  update_sub_account_success: "Tài khoản phụ được cập nhật thành công!",
  unblock_account_profile_confirm: "Bạn có chắc chắn muốn bỏ chặn hồ sơ tài khoản?",
  unblock_account_profile_cancel: "Bỏ chặn hồ sơ tài khoản không thành công.",
  unblock_account_profile_success: "Hồ sơ tài khoản đã được bỏ chặn thành công!",
  settlement_confirm: "Bạn có chắc chắn muốn tiến hành giải quyết?",
  settlement_cancel: "giải quyết thất bại",
  settlement_success: "Giải quyết thành công!",
  settlement_not_allowed: "Giải quyết không được phép ngày hôm nay!",
  search_with_working_date: "Tìm kiếm với ngày làm việc",
  system_error: "Hệ thống không thể xử lý yêu cầu của bạn.",
  invalid_password: "Sai Tên người sử dụng hoặc Mật khẩu.",
  invalid_account: "Tài khoản này không hợp lệ.",
  block: "Tài khoản của bạn đã bị khóa.",
  invalid_security_code: "Mã bảo mật không hợp lệ.",
  source_account_id_required: "ID tài khoản là bắt buộc.",
  target_account_id_required: "ID tài khoản mục tiêu là bắt buộc.",
  account_id_required: "ID tài khoản là bắt buộc.",
  sub_login_id_required: "ID đăng nhập là bắt buộc.",
  account_not_exists: "Tài khoản này không hợp lệ.",
  profile_not_exists: "Tài khoản này không hợp lệ.",
  account_inactive: "Tài khoản không hoạt động.",
  not_blocked_account: "Tài Khoản Có thể sử dụng.",
  password_required: "Mật khẩu là bắt buộc.",
  parent_id_required: "ID phụ huynh là bắt buộc.",
  parent_not_exists:"Tài khoản này không hợp lệ.",
  invalid_account_type: "Loại tài khoản không hợp lệ.",
  account_exists: "Tài khoản đã tồn tại.",
  login_id_required: "ID đăng nhập là bắt buộc.",
  new_login_id_required: "ID đăng nhập mới là bắt buộc.",
  login_id_not_exists: "ID đăng nhập không hợp lệ.",
  invalid_authority_role: "Vai trò không hợp lệ.",
  profile_inactive: "Hồ sơ không hợp lệ.",
  secondary_account_exists: "Tài khoản phụ đã tồn tại.",
  new_login_id_exists: "ID đăng nhập mới đã tồn tại.",
  new_password_required: "Mật khẩu mới là bắt buộc.",
  security_tag_required: "Thẻ bảo mật bắt buộc",
  security_code_required: "Mã bảo mật là bắt buộc.",
  start_date_required: "Ngày bắt đầu là bắt buộc.",
  end_date_required: "Ngày kết thúc là bắt buộc.",
  start_date_gt_end_date: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  start_date_greater_end_date: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  member_id_required: "ID thành viên là bắt buộc.",
  currency_code_required: "Mã tiền tệ là bắt buộc.",
  commission_setting_not_exists: "Thiết lập hoa hồng không tồn tại.",
  incomplete_account_line: "Dòng tài khoản không đầy đủ.",
  invalid_hdp_package: "Gói HDP không hợp lệ.",
  search_id_required: "ID tìm kiếm là bắt buộc.",
  profile_id_required: "ID hồ sơ là bắt buộc.",
  login_not_exists: "ID đăng nhập không hợp lệ.",
  no_changes: "Không có thay đổi được phát hiện.",
  start_date_require: "Ngày bắt đầu là bắt buộc.",
  league_id_required: "liên đoàn ID is required.",
  sport_type_required: "Loại hình thể thao là bắt buộc.",
  match_id_required: "giải đấu ID is required.",
  target_login_id_required: "ID đăng nhập mục tiêu là bắt buộc.",
  parent_account_not_exists: "Tài khoản này không hợp lệ.",
  parent_account_inactive: "Tài khoản phụ huynh không hoạt động.",
  parent_profile_not_exists: "Tài khoản này không hợp lệ ..",
  parent_profile_inactive: "Hồ sơ phụ huynh không hoạt động.",
  target_login_id_not_exists: "Tài khoản này không hợp lệ.",
  incorrect_parent: "ID cha không hợp lệ.",
  invalid_session: "Yêu cầu phiên không hợp lệ.",
  session_expired: "Phiên hết hạn.",
  settle_amount_required: "phải giải quyết số tiền.",
  invalid_settle_amount: "Số tiền giải quyết không hợp lệ.",
  settle_amount_gt_yesterday_balance: "Số tiền thanh toán lớn hơn số dư của ngày hôm qua.",
  invalid_account_status: "Trạng thái tài khoản không hợp lệ.",
  bet_limit_packages_required: "Các gói giới hạn đặt cược là bắt buộc.",
  bet_limit_exists: "Giới hạn cá cược đã tồn tại.",
  member_bet_limit_package_gt_one: "Gói giới hạn đặt cược thành viên là nhiều hơn một.",
  parent_bet_limit_not_exists: "Giới hạn đặt cược của cha mẹ không tồn tại.",
  account_commission_required: "Hoa hồng tài khoản là bắt buộc.",
  commission_setting_exists: "Thiết lập hoa hồng đã tồn tại.",
  parent_comm_not_exists: "đại lý tuyến trên cHoa hồng Xác lập does not exits.",
  exceeded_parent_comm: "Vượt quá đại lý tuyến trên Hoa hồng Xác lập.",
  others_commission_required: "Các cài đặt hoa hồng khác là bắt buộc.",
  exceeded_parent_1x2: "Vượt quá đại lý tuyến trên 1x2 Hoa hồng Xác lập.",
  exceeded_parent_other: "Vượt quá đại lý tuyến trên other Hoa hồng Xác lập.",
  hdp_commission_required: "HDP Hoa hồng Xác lập Cần.",
  exceeded_parent_hdp_a: "Vượt quá HPD(A) Hoa hồng Xác lập.",
  exceeded_parent_hdp_b: "Vượt quá HPD(B) Hoa hồng Xác lập.",
  exceeded_parent_hdp_c: "Vượt quá HPD(C) Hoa hồng Xác lập.",
  exceeded_parent_hdp_d: "Vượt quá HPD(D) Hoa hồng Xác lập.",
  exceeded_parent_hdp_e: "Vượt quá HPD(E) Hoa hồng Xác lập.",
  exceeded_parent_hdp_f: "Vượt quá HPD(F) Hoa hồng Xác lập.",
  exceeded_parent_hdp_g: "Vượt quá HPD(G) Hoa hồng Xác lập.",
  exceeded_parent_hdp_h: "Vượt quá HPD(H) Hoa hồng Xác lập.",
  exceeded_parent_hdp_i: "Vượt quá HPD(I) Hoa hồng Xác lập.",
  exceeded_parent_hdp_j: "Vượt quá HPD(J) Hoa hồng Xác lập.",
  livecasino_upline_pt_required: "[Sòng Bài Live] PT đại lý tuyến trên nhu cầu.",
  livecasino_pt_setting_exists: "[Sòng Bài Live] Xác lập đại lý tuyến trên PT tồn tại.",
  livecasino_parent_pt_not_exists: "[Sòng Bài Live] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  livecasino_parent_min_not_meet: "[Sòng Bài Live] đại lý tuyến trên tối thiểu PT Không được phép .",
  livecasino_exceeded_parent_pt: "[Sòng Bài Live] PT đại lý tuyến trên Xác lập thêm .",
  livecasino_account_pt_required: "[Sòng Bài Live] Tài Khoản PT Xác lập Cần.",
  livecasino_upline_remaining_required: "[Sòng Bài Live] đại lý tuyến trên remaining Xác lập Cần.",
  livecasino_account_min_required: "[Sòng Bài Live] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  livecasino_upline_remaining_gt_account_pt: "[Sòng Bài Live] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  livecasino_account_min_gt_p: "[Sòng Bài Live] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  slots_upline_pt_required: "[Trò Chơi Sòng Bài] Xác lập đại lý tuyến trên PT tồn tại.",
  slots_pt_setting_exists: "[Trò Chơi Sòng Bài] PT Xác lập tồn tại.",
  slots_parent_pt_not_exists: "[Trò Chơi Sòng Bài] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  slots_parent_min_not_meet: "[Trò Chơi Sòng Bài] đại lý tuyến trên tối thiểu PT Không được phép.",
  slots_exceeded_parent_pt: "[Trò Chơi Sòng Bài] PT đại lý tuyến trên Xác lập thêm.",
  slots_account_pt_required: "[Trò Chơi Sòng Bài] PT Tài Khoản Xác lập Cần.",
  slots_upline_remaining_required: "[Trò Chơi Sòng Bài] đại lý tuyến trên remaining Xác lập Cần.",
  slots_account_min_required: "[Trò Chơi Sòng Bài] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  slots_upline_remaining_gt_account_pt: "[Trò Chơi Sòng Bài] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  slots_account_min_gt_pt: "[Trò Chơi Sòng Bài] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  lotto_upline_pt_required: "[Lotto] Xác lập đại lý tuyến trên PT tồn tại.",
  lotto_pt_setting_exists: "[Lotto] PT Xác lập tồn tại.",
  lotto_parent_pt_not_exists: "[Lotto] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  lotto_parent_min_not_meet: "[Lotto] đại lý tuyến trên tối thiểu PT Không được phép.",
  lotto_exceeded_parent_pt: "[Lotto] PT đại lý tuyến trên Xác lập thêm.",
  lotto_account_pt_required: "[Lotto] PT Tài Khoản Xác lập Cần.",
  lotto_upline_remaining_required: "[Lotto] đại lý tuyến trên remaining Xác lập Cần.",
  lotto_account_min_required: "[Lotto] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  lotto_upline_remaining_gt_account_pt: "[Lotto] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  lotto_account_min_gt_pt: "[Lotto] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  keno_upline_pt_required: "[Keno] Xác lập đại lý tuyến trên PT tồn tại.",
  keno_pt_setting_exists: "[Keno] PT Xác lập tồn tại.",
  keno_parent_pt_not_exists: "[Keno] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  keno_parent_min_not_meet: "[Keno] đại lý tuyến trên tối thiểu PT Không được phép.",
  keno_exceeded_parent_pt: "[Keno] PT đại lý tuyến trên Xác lập thêm.",
  keno_account_pt_required: "[Keno] PT Tài Khoản Xác lập Cần.",
  keno_upline_remaining_required: "[Keno] đại lý tuyến trên remaining Xác lập Cần.",
  keno_account_min_required: "[Keno] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  keno_upline_remaining_gt_account_pt: "[Keno] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  keno_account_min_gt_pt: "[Keno] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  cockfight_upline_pt_required: "[Cuộc đá gà] Xác lập đại lý tuyến trên PT tồn tại.",
  cockfight_pt_setting_exists: "[Cuộc đá gà] PT Xác lập tồn tại.",
  cockfight_parent_pt_not_exists: "[Cuộc đá gà] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  cockfight_parent_min_not_meet: "[Cuộc đá gà] đại lý tuyến trên tối thiểu PT Không được phép.",
  cockfight_exceeded_parent_pt: "[Cuộc đá gà] PT đại lý tuyến trên Xác lập thêm.",
  cockfight_account_pt_required: "[Cuộc đá gà] PT Tài Khoản Xác lập Cần.",
  cockfight_upline_remaining_required: "[Cuộc đá gà] đại lý tuyến trên remaining Xác lập Cần.",
  cockfight_account_min_required: "[Cuộc đá gà] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  cockfight_upline_remaining_gt_account_pt: "[Cuộc đá gà] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  cockfight_account_min_gt_pt: "[Cuộc đá gà] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  lottery_upline_pt_required: "[Xổ số] Xác lập đại lý tuyến trên PT tồn tại.",
  lottery_pt_setting_exists: "[Xổ số] PT Xác lập tồn tại.",
  lottery_parent_pt_not_exists: "[Xổ số] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  lottery_parent_min_not_meet: "[Xổ số] đại lý tuyến trên tối thiểu PT Không được phép.",
  lottery_exceeded_parent_pt: "[Xổ số] PT đại lý tuyến trên Xác lập thêm.",
  lottery_account_pt_required: "[Xổ số] PT Tài Khoản Xác lập Cần.",
  lottery_upline_remaining_required: "[Xổ số] đại lý tuyến trên remaining Xác lập Cần.",
  lottery_account_min_required: "[Xổ số] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  lottery_upline_remaining_gt_account_pt: "[Xổ số] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  lottery_account_min_gt_pt: "[Xổ số] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  bet_type_required: "Lọai cược nhu cầu",
  schedule_1_to_7_required: "Thanh toán Ngày nhu cầu",
  schedule_exists: "Thanh toán Ngày nhu cầu tồn tại.",
  parent_schedule_not_exists: "Thanh toán đại lý tuyến trên Ngày nhu cầu Không tồn tại.",
  schedule_1_not_available: "Thứ hai Thanh toán không cho phép.",
  schedule_2_not_available: "Thứ ba Thanh toán không cho phép.",
  schedule_3_not_available: "Thứ tư Thanh toán không cho phép.",
  schedule_4_not_available: "Thứ năm Thanh toán không cho phép.",
  schedule_5_not_available: "Thứ sáu Thanh toán không cho phép.",
  schedule_6_not_available: "Thứ bảy Thanh toán không cho phép.",
  schedule_7_not_available: "Chủ nhật Thanh toán  không cho phép.",
  credit_limit_required: "Giới Hạn Tín Dụng Cần.",
  member_credit_limit_required: "Tín Dụng Thành Viên Cần.",
  wallet_exists: "Tín Dụng tồn tại.",
  member_credit_limit_gt_credit_limit: "Tín Dụng Thành Viên Vượt quá Tín Dụng.",
  parent_wallet_not_exists: "đại lý tuyến trên Tín Dụng không tồn tại.",
  account_credit_limit_gt_parent: "Tín Dụng Tài Khoản Vượt quá đại lý tuyến trên .",
  member_credit_limit_gt_parent: "Tín Dụng Thành Viên Vượt quá đại lý tuyến trên",
  exceeded_credit_limit: "Vượt quá Tín Dụng.",
  soccer_min_bet_required: "Bóng Đá Đặt cược tối thiểu Cần .",
  soccer_max_bet_required: "Bóng Đá Đặt Cược Tối Đa Cần.",
  soccer_max_per_match_required: "Bóng Đá Tối Đa Cho Mỗi Trận Cần.",
  soccer_bet_limit_exists: "Bóng Đá Giới hạn cá cược tồn tại.",
  soccer_parent_bet_limit_not_exists: "Bóng Đá đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  soccer_account_min_bet_lt_parent: "Bóng Đá Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  soccer_account_max_bet_gt_parent: "Bóng Đá Đặt Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  soccer_account_max_per_match_gt_parent: "Bóng Đá Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  basketball_min_bet_required: "Bóng Rổ Đặt cược tối thiểu Cần.",
  basketball_max_bet_required: "Bóng Rổ Đặt Cược Tối Đa Cần.",
  basketball_max_per_match_required: "Bóng Rổ Maximum bet per match is required",
  basketball_bet_limit_exists: "Bóng Rổ Tối Đa Cho Mỗi Trận Cần.",
  basketball_parent_bet_limit_not_exists: "Bóng Rổ Parent bet limit does not exists.",
  basketball_account_min_bet_lt_parent: "Bóng Rổ Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  basketball_account_max_bet_gt_parent: "Bóng Rổ Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  basketball_account_max_per_match_gt_parent: "Bóng Rổ Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  tennis_min_bet_required: "Quần Vợt Đặt cược tối thiểu Cần.",
  tennis_max_bet_required: "Quần Vợt Đặt Cược Tối Đa Cần.",
  tennis_max_per_match_required: "Quần Vợt Tối Đa Cho Mỗi Trận Cần",
  tennis_bet_limit_exists: "Quần Vợt Giới hạn cá cược tồn tại.",
  tennis_parent_bet_limit_not_exists: "Quần Vợt đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  tennis_account_min_bet_lt_parent: "Quần Vợt Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  tennis_account_max_bet_gt_parent: "Quần Vợt Đặt Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  tennis_account_max_per_match_gt_parent: "Quần Vợt Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  baseball_min_bet_required: "Bóng Chày Đặt cược tối thiểu Cần.",
  baseball_max_bet_required: "Bóng Chày Đặt Cược Tối Đa Cần.",
  baseball_max_per_match_required: "Bóng Chày Tối Đa Cho Mỗi Trận Cần",
  baseball_bet_limit_exists: "Bóng Chày Giới hạn cá cược tồn tại.",
  baseball_parent_bet_limit_not_exists: "Bóng Chày đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  baseball_account_min_bet_lt_parent: "Bóng Chày Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  baseball_account_max_bet_gt_parent: "Bóng Chày Đặt Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  baseball_account_max_per_match_gt_parent: "Bóng Chày Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  parlay_min_bet_required: "Đặt Cựơc Dồn Vợt Đặt cược tối thiểu Cần.",
  parlay_max_bet_required: "Đặt Cựơc Dồn Đặt Cược Tối Đa Cần.",
  parlay_max_per_match_required: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận Cần",
  parlay_bet_limit_exists: "Đặt Cựơc Dồn Giới hạn cá cược tồn tại.",
  parlay_parent_bet_limit_not_exists: "Đặt Cựơc Dồn đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  parlay_account_min_bet_lt_parent: "Đặt Cựơc Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  parlay_account_max_bet_gt_parent: "Đặt Cựơc Dồn Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  parlay_account_max_per_match_gt_parent: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  esports_min_bet_required: "Thể thao điện tử Dồn Vợt Đặt cược tối thiểu Cần.",
  esports_max_bet_required: "Thể thao điện tử Đặt Cược Tối Đa Cần.",
  esports_max_per_match_required: "Thể thao điện tử Tối Đa Cho Mỗi Trận Cần",
  esports_bet_limit_exists: "Thể thao điện tử Giới hạn cá cược tồn tại.",
  esports_parent_bet_limit_not_exists: "Thể thao điện tử đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  esports_account_min_bet_lt_parent: "Thể thao điện tử Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  esports_account_max_bet_gt_parent: "Thể thao điện tử Cược Tối Đa Tín Vượt quá đại lý tuyến trên.",
  esports_account_max_per_match_gt_parent: "Thể thao điện tử Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",

  others_min_bet_required: "Thể loại khác Dồn Vợt Đặt cược tối thiểu Cần.",
  others_max_bet_required: "Thể loại khác Đặt Cược Tối Đa Cần.",
  others_max_per_match_required: "Thể loại khác Tối Đa Cho Mỗi Trận Cần",
  others_bet_limit_exists: "Thể loại khác Giới hạn cá cược tồn tại.",
  others_parent_bet_limit_not_exists: "Thể loại khác đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  others_account_min_bet_lt_parent: "Thể loại khác Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  others_account_max_bet_gt_parent: "Thể loại khác Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  others_account_max_per_match_gt_parent: "Thể loại khác Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",

  cs_min_bet_required: "Yêu cầu đặt cược tối thiểu có tỷ số chính xác.",
  cs_max_bet_required: "Yêu cầu đặt cược tối đa theo tỷ số chính xác..",
  cs_max_per_match_required: "Yêu cầu Điểm tối đa chính xác cho mỗi trận đấu.",
  cs_bet_limit_exists: "Có giới hạn đặt cược Tỷ số chính xác.",
  cs_parent_bet_limit_not_exists: "Giới hạn đặt cược gốc của Tỷ số chính xác không tồn tại.",
  cs_account_min_bet_lt_parent: "Điểm chính xác Đặt cược tối thiểu Thấp hơn đại lý tuyến trên.",
  cs_account_max_bet_gt_parent: "Điểm chính xác Đặt cược tối đa lớn hơn đại lý tuyến trên.",
  cs_account_max_per_match_gt_parent: "Điểm chính xác Tối đa mỗi trận lớn hơn đại lý tuyến trên.",

  used_credit_gt_credit_limit: "Tín dụng đã qua sử dụng Vượt quá Tín Dụng Giới Hạn.",
  bet_limit_setting_not_exists: "Giới Hạn Cược Xác lập không tồn tại.",
  parent_bet_limit_setting_not_exists: "đại lý tuyến trên Giới Hạn Cược Xác lập không tồn tại .",
  package_not_exists_in_parent: "đại lý tuyến trên Giới Hạn Cược gói Xác lập không tồn tại",
  soccer_bet_limit_setting_not_exists: "Bóng Đá Giới Hạn Cược Xác lập không tồn tại.",
  soccer_update_interval_violated: "Bóng Đá Cập nhật vi phạm khoảng .",
  basketball_bet_limit_setting_not_exists: "Bóng Rổ Giới Hạn Cược Xác lập không tồn tại.",
  basketball_update_interval_violated: "Bóng Rổ Cập nhật vi phạm khoảng.",
  tennis_bet_limit_setting_not_exists:"Quần Vợt Giới Hạn Cược Xác lập không tồn tại.",
  tennis_update_interval_violated: "Quần Vợt Update interval violated.",
  baseball_bet_limit_setting_not_exists:"Bóng Chày Giới Hạn Cược Xác lập không tồn tại.",
  baseball_update_interval_violated: "Bóng Chày Cập nhật vi phạm khoảng.",
  parlay_bet_limit_setting_not_exists:"Đặt Cựơc Dồn Giới Hạn Cược Xác lập không tồn tại.",
  parlay_update_interval_violated: "Đặt Cựơc Dồn Cập nhật vi phạm khoảng.",
  esports_bet_limit_setting_not_exists:"Thể thao điện tử Giới Hạn Cược Xác lập không tồn tại.",
  esports_update_interval_violated: "Thể thao điện tử Cập nhật vi phạm khoảng.",
  others_bet_limit_setting_not_exists:"Thể loại khác Giới Hạn Cược Xác lập không tồn tại.",
  others_update_interval_violated: "Thể loại khác Cập nhật vi phạm khoảng.",
  cs_bet_limit_setting_not_exists:"Cài đặt giới hạn cược tỷ số chính xác không tồn tại.",
  cs_update_interval_violated: "Khoảng thời gian cập nhật điểm đúng bị vi phạm.",
  soccer_parent_bet_limit_setting_not_exists: "Bóng Đá đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  soccer_min_bet_lt_parent: "Bóng Đá Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  soccer_max_bet_gt_parent: "Bóng Đá Đặt Cược Tối Đa Vượt quá đại lý tuyến trên.",
  soccer_max_per_match_gt_parent: "Bóng Đá Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  basketball_parent_bet_limit_setting_not_exists: "Bóng Rổ parent đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  basketball_min_bet_lt_parent: "Bóng Rổ Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  basketball_max_bet_gt_parent: "Bóng Rổ Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  basketball_max_per_match_gt_parent: "Bóng Rổ Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  tennis_parent_bet_limit_setting_not_exists: "Quần Vợt đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  tennis_min_bet_lt_parent: "Quần Vợt Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  tennis_max_bet_gt_parent: "Quần Vợt Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  tennis_max_per_match_gt_parent: "Quần Vợt Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  baseball_parent_bet_limit_setting_not_exists: "Bóng Chày đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  baseball_min_bet_lt_parent: "Bóng Chày Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  baseball_max_bet_gt_parent: "Bóng Chày Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  baseball_max_per_match_gt_parent: "Bóng Chày Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  parlay_parent_bet_limit_setting_not_exists: "Đặt Cựơc Dồn đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  parlay_min_bet_lt_parent: "Đặt Cựơc Dồn Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  parlay_max_bet_gt_parent: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  parlay_max_per_match_gt_parent: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  esports_parent_bet_limit_setting_not_exists: "Thể thao điện tử đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  esports_min_bet_lt_parent: "Thể thao điện tử Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  esports_max_bet_gt_parent: "Thể thao điện tử Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  esports_max_per_match_gt_parent: "Thể thao điện tử Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  others_parent_bet_limit_setting_not_exists: "Thể loại khác đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  others_min_bet_lt_parent: "Thể loại khác Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  others_max_bet_gt_parent: "Thể loại khác Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  others_max_per_match_gt_parent: "Thể loại khác Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",

  cs_parent_bet_limit_setting_not_exists: "Điểm chính xác của đại lý tuyến trên đặt cược Cài đặt giới hạn không tồn tại.",
  cs_min_bet_lt_parent: "Đúng Điểm đặt cược tối thiểu thấp hơn đại lý tuyến trên.",
  cs_max_bet_gt_parent: "Đúng Điểm đặt cược tối đa lớn hơn đại lý tuyến trên.",
  cs_max_per_match_gt_parent: "Đúng Điểm tối đa mỗi trận lớn hơn đại lý tuyến trên.",

  cs_min_bet_lt_soccer: "Đặt cược tỷ số tối thiểu chính xác thấp hơn đặt cược tối thiểu bóng đá.",
  cs_max_bet_gt_soccer: "Cược tỷ số tối đa chính xác lớn hơn cược tối đa bóng đá.",
  cs_max_per_match_gt_soccer: "Tỷ số chính xác tối đa mỗi trận lớn hơn tỷ số tối đa bóng đá mỗi trận.",

  update_interval_violated: "Cập nhật vi phạm khoảng.",
  exceeded_parent_others: "Hoa Hồng đại lý Vượt quá.",
  exceeded_parent_hdp: "HDP đại lý Vượt quá.",
  no_information_available: "Không có tin.",
  request_processing: "Yêu cầu gia công...",
  new_login_id_format_error: "Chỉ có chữ in hoa nhỏ Từ a to z & 0 to 9.",
  account_id_format_error: "Chỉ có chữ in hoa nhỏ Từ a to z & 0 to 9.",
  inactive_account: "Tài Khoản Đã đóng / Bị treo giò. Liên hệ.",

  sportsbook_account_pt_gt_92: "Phần thầu của Super Senior không thể lớn hơn 92%",
  pending_result: "Kết quả chờ xử lý",
  insufficient_balance: "Thiếu cân bằng",
  ok: "Hoàn thành",
  settlement_warning: "Cảnh báo: nếu số dư được chuyển hoàn toàn, các thành viên được đánh dấu bên dưới sẽ có tín dụng đặt cược âm và do đó, họ có thể mất nhiều hơn tín dụng đã cho.",
  jackpot_alert: "Đối với bất kỳ khoản thanh toán jackpot lũy tiến nào vượt quá 100.000 MYR (1.000.000 THB), WBET sẽ chịu chi phí cho toàn bộ số tiền.",
  accumulate_alert: "Giới hạn thắng sẽ được đặt lại sau khi danh sách hoàn tiền về đã được giải quyết.",
  authorityOptionRequired: "Please choose at least one authority",

  add_key_confirm: "Are you sure want to add key?",
  add_key_success: "Key successfully added!",
  update_key_confirm: "Are you sure want to update key?",
  update_key_success: "Key successfully updated!",
  targetAccountIdContainReservedWord: "Username contain reserved words",
  update_bet_limit_setting: "Are you sure want to update bet limit setting?",
  update_bet_limit_setting_cancel: "Update bet limit failed.",
  update_bet_limit_succeed: "Bet limit successfully updated!",

  update_account_hdp_packages_confirm: "Are you sure want to update account hdp packages?",
  update_account_hdp_packages_cancel: "Update account hdp packages failed.",
  update_account_hdp_packages_success: "Account hdp packages successfully updated!",

  cash_deposit_confirm: "Are you sure want to deposit cash?",
  cash_deposit_cancel: "Deposit cash failed.",
  cash_deposit_success: "Deposit cash successfully updated!",

  cash_withdrawal_confirm: "Are you sure want to withdraw cash?",
  cash_withdrawal_cancel: "Withdraw cash failed.",
  cash_withdrawal_success: "Withdraw cash successfully updated!",

  welcome_to_wbet: "Welcome To WBET!",
  invalid_parameter: "Invalid parameter.",
  action_by_required: "Action by is required.",
  invalid_action_by: "Invalid action by.",
  invalid_account_id: "Invalid account ID.",
  invalid_profile_id: "Invalid profile ID.",
  session_token_required: "Session token is required.",
  invalid_session_token: "Invalid session token.",
  invalid_target_account_id: "Invalid target account ID.",
  invalid_search_id: "Invalid search ID.",
  invalid_start_date: "Invalid start date.",
  invalid_end_date: "Invalid end date.",
  invalid_page_number: "Invalid page number.",
  invalid_page_size: "Invalid page size.",
  invalid_account_status: "Invalid account status.",
  invalid_soccer_min_bet: "Invalid min bet.",
  invalid_soccer_max_bet: "Invalid max bet.",
  invalid_soccer_max_per_match: "Invalid maximum bet per match.",
  soccer_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  soccer_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_basketball_min_bet: "Invalid min bet.",
  invalid_basketball_max_bet: "Invalid max bet.",
  invalid_basketball_max_per_match: "Invalid maximum bet per match.",
  basketball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  basketball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_tennis_min_bet: "Invalid min bet.",
  invalid_tennis_max_bet: "Invalid max bet.",
  invalid_tennis_max_per_match: "Invalid maximum bet per match.",
  tennis_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  tennis_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_baseball_min_bet: "Invalid min bet.",
  invalid_baseball_max_bet: "Invalid max bet.",
  invalid_baseball_max_per_match: "Invalid maximum bet per match.",
  baseball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  baseball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_parlay_min_bet: "Invalid min bet.",
  invalid_parlay_max_bet: "Invalid max bet.",
  invalid_parlay_max_per_match: "Invalid maximum bet per match.",
  parlay_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  parlay_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_esports_min_bet: "Invalid min bet.",
  invalid_esports_max_bet: "Invalid max bet.",
  invalid_esports_max_per_match: "Invalid maximum bet per match.",
  esports_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  esports_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_others_min_bet: "Invalid min bet.",
  invalid_others_max_bet: "Invalid max bet.",
  invalid_others_max_per_match: "Invalid maximum bet per match.",
  others_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  others_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",

  invalid_cs_min_bet: "Invalid min bet.",
  invalid_cs_max_bet: "Invalid max bet.",
  invalid_cs_max_per_match: "Invalid maximum bet per match.",
  cs_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  cs_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",

  invalid_passwords: "Invalid password.",
  invalid_account_type: "Invalid account type.",
  invalid_full_name: "Invalid full name.",
  invalid_contact_email: "Invalid contact email.",
  invalid_contact_phone: "Invalid contact phone.",
  invalid_audit_by: "Invalid audit by.",
  invalid_remark: "Invalid remark.",
  target_profile_id_required: "Target profile ID is required.",
  invalid_target_profile_id: "Invalid target profile ID.",
  invalid_sub_login_id: "Invalid sub login ID.",
  invalid_sort_key: "Invalid sort key.",
  invalid_sort_type: "Invalid sort type.",
  invalid_new_login_id: "Invalid new login ID.",
  invalid_new_password: "Invalid new password.",
  invalid_security_tag: "Invalid security tag.",
  invalid_security_code: "Invalid security code.",
  authority_option_required: "Please choose at least one authority.",
  invalid_authority_option: "Invalid authority option.",
  ip_required: "IP is required.",
  invalid_ip: "Invalid IP",
  suffix_required: "Suffix is required.",
  invalid_suffix: "Invalid suffix.",
  type_required: "Type is required.",
  invalid_type: "Invalid type.",
  callbackurl_required: "Callbackurl is required.",
  invalid_callbackurl: "Invalid callbackurl.",
  email_required: "Email is required.",
  invalid_email: "Invalid email.",
  apistatus_required: "Apistatus is required.",
  invalid_apistatus: "Invalid apistatus.",
  invalid_login_id: "Invalid login ID.",
  invalid_loginsource: "Invalid login source.",
  hdp_package_required: "HDP package required.",
  invalid_target_login_id: "Invalid target login ID.",
  status_required: "Status is required.",
  invalid_status: "Invalid status.",
  amount_required: "Amount is required.",
  invalid_amount: "Invalid amount.",
  method_required: "Method is required.",
  invalid_method: "Invalid method.",
  soccer_hdp_upline_pt_required: "HDP upline PT is required.",
  soccer_hdp_account_pt_required: "HDP account PT is required.",
  soccer_hdp_upline_remaining_required: "HDP upline remaining is required.",
  soccer_hdp_account_min_required: "HDP account minimum is required.",
  soccer_hdp_pt_setting_not_exists: "HDP PT setting does not exists.",
  soccer_hdp_parent_pt_not_exists: "HDP parent PT does not exists.",
  soccer_hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  soccer_hdp_upline_remaining_gt_account_pt: "HDP upline remaining greater than account PT.",
  soccer_hdp_account_min_gt_pt: "HDP account minimum greater than PT",
  soccer_hdp_account_pt_lt_downline: "HDP account PT lower than downline.",

  invalid_soccer_hdp_upline_pt: "Invalid HDP upline PT.",
  soccer_1x2_upline_pt_required: "1x2 upline PT is required.",
  soccer_1x2_account_pt_required: "1x2 account PT is required.",
  soccer_1x2_upline_remaining_required: "1x2 upline remaining is required.",
  soccer_1x2_account_min_required: "1x2 account minimum is required.",
  soccer_1x2_pt_setting_not_exists: "1x2 PT setting does not exists.",
  soccer_1x2_parent_pt_not_exists: "1x2 parent PT does not exists.",
  soccer_1x2_exceeded_parent_pt: "1x2 exceeded parent PT.",
  soccer_1x2_upline_remaining_gt_account_pt: "1x2 upline remaining greater than account PT.",
  soccer_1x2_account_min_gt_pt: "1x2 account minimum greater than PT",
  soccer_1x2_account_pt_lt_downline: "1x2 account PT lower than downline.",
  
  invalid_soccer_1x2_upline_pt: "Invalid 1x2 upline PT.",
  soccer_others_upline_pt_required: "Others upline PT is required.",
  soccer_others_account_pt_required: "Others account PT is required.",
  soccer_others_upline_remaining_required: "Others upline remaining is required.",
  soccer_others_account_min_required: "Others account minimum is required.",
  soccer_others_pt_setting_not_exists: "Others PT setting does not exists.",
  soccer_others_parent_pt_not_exists: "Others parent PT does not exists.",
  soccer_others_exceeded_parent_pt: "Others exceeded parent PT.",
  soccer_others_upline_remaining_gt_account_pt: "Others upline remaining greater than account PT.",
  soccer_others_account_min_gt_pt: "Others account minimum greater than PT",
  soccer_others_account_pt_lt_downline: "Others account PT lower than downline.",

  invalid_soccer_others_upline_pt: "Invalid others upline PT.",
  parlay_upline_pt_required: "Parlay upline PT is required.",
  parlay_account_pt_required: "Parlay account PT is required.",
  parlay_upline_remaining_required: "Parlay upline remaining is required.",
  parlay_account_min_required: "Parlay account minimum is required.",
  parlay_pt_setting_not_exists: "Parlay PT setting does not exists.",
  parlay_parent_pt_not_exists: "Parlay parent PT does not exists.",
  parlay_exceeded_parent_pt: "Parlay exceeded parent PT.",
  parlay_upline_remaining_gt_account_pt: "Parlay upline remaining greater than account PT.",
  parlay_account_min_gt_pt: "Parlay account minimum greater than PT",
  parlay_account_pt_lt_downline: "Parlay account PT lower than downline.",

  invalid_parlay_upline_pt: "Invalid parlay upline PT .",
  invalid_member_id: "Invalid member ID.",
  invalid_sport_type: "Invalid sport type.",
  invalid_league_id: "Invalid league ID.",
  invalid_match_id: "Invalid match ID.",
  working_date_required: "Working date is required.",
  invalid_working_date: "Invalid working date.",
  game_type_required: "Game type is required.",
  invalid_game_type: "Invalid game type.",
  bet_id_required: "Bet ID is required.",
  invalid_bet_id: "Invalid bet ID.",
  hdp_packages_not_exists: "HDP package does not exists.",
  parent_hdp_packages_not_exists: "Parent HDP package does not exists.",
  invalid_bet_type: "Invalid bet type.",
  invalid_match_id: "Invalid Match ID.",
  invalid_home_running_score: "Invalid Home Running Score.",
  invalid_away_running_score: "Invalid Away Running Score.",
  invalid_home_away: "Invalid Home Away.",

  operator_account_not_exists: "Operator account does not exists.",
  insert_main_failed: "Insert main failed.",
  delete_child_failed: "Delete child failed.",
  insert_child_failed: "Insert child failed.",
  invalid_operator: "Invalid operator.",
  invalid_master: "Invalid master.",
  duplicate_suffix: "Duplicate suffix.",
  insert_error: "Insert error.",
  allow_to_add_multiple_ip: "Allow to add multiple IP, eg. 192.168.1.1,192.168.1.2",
  only_allow_proper_url: "URL must be start with http or https, eg. https://xxxxxx.com",
};
